export const companyDocumentConfigs = [
  { key: 'insurance', label: 'Insurance' },
  { key: 'mcs150', label: 'Form MCS-150' },
  { key: 'irp_registration', label: 'IRP Registration' },
  { key: 'ucr', label: 'UCR' },
  { key: 'scac', label: 'SOS Annual Renewals' }
] as const

export type CompanyDocumentKey = typeof companyDocumentConfigs[number]['key']

export type CompanyDocumentField<T extends 'from' | 'to'> = `${CompanyDocumentKey}_valid_${T}`

export const getCompanyDocumentFieldName = <T extends 'from' | 'to'>(key: CompanyDocumentKey, type: T): CompanyDocumentField<T> =>
  `${key}_valid_${type}` as CompanyDocumentField<T>

export const companyDocumentLabels = companyDocumentConfigs.reduce<Record<string, string>>((acc, doc) => {
  acc[doc.key] = doc.label
  return acc
}, {})
